var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row mt-3" }, [
    _c("div", { staticClass: "col-xs-12" }, [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card__content" }, [
          _c("div", { staticClass: "card__title" }, [
            _c("h4", [
              _vm._v(
                "Documentos pendientes por enviar (" +
                  _vm._s(
                    _vm.autorizacionDocumentos.documentosPendientesEnviar.length
                  ) +
                  ")"
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "table-responsive" }, [
            _c("table", [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "tbody",
                [
                  _c(
                    "tr",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.autorizacionDocumentos
                              .documentosPendientesEnviar.length === 0,
                          expression:
                            "autorizacionDocumentos.documentosPendientesEnviar.length === 0"
                        }
                      ]
                    },
                    [
                      _c(
                        "td",
                        { attrs: { colspan: !_vm.form.en_cola ? 8 : 7 } },
                        [_c("strong", [_vm._v("No se encontró registros.")])]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(
                    _vm.autorizacionDocumentos.documentosPendientesEnviar,
                    function(comprobante, index) {
                      return _c(
                        "tr",
                        {
                          key: index,
                          class: {
                            "tr--canceled": comprobante.tiene_error === "S"
                          }
                        },
                        [
                          _c("td", [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  comprobante.tipo_comprobante.descripcion
                                ) +
                                "\n                "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(comprobante.numero_documento))
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(comprobante.fecha_emision_comprobante)
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(comprobante.cliente.nombre))
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                comprobante.valor_total !== null
                                  ? "$" +
                                      parseFloat(
                                        comprobante.valor_total
                                      ).toLocaleString(_vm.locale)
                                  : ""
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  comprobante.tiene_error === "S" ? "Sí" : "No"
                                ) +
                                "\n                "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "table-actions" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn-info btn--text",
                                attrs: {
                                  tooltip: "Visualizar",
                                  type: "button"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.visualizarComprobante(
                                      comprobante
                                    )
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fa fa-eye" })]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn-secondary btn--text",
                                attrs: { type: "button", tooltip: "Logs" },
                                on: {
                                  click: function($event) {
                                    return _vm.mostrarEventosComprobante(
                                      comprobante.id_comprobante
                                    )
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fa fa-file-o" })]
                            )
                          ])
                        ]
                      )
                    }
                  )
                ],
                2
              )
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-xs-12 mt-2" }, [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card__content" }, [
          _c("div", { staticClass: "card__title" }, [
            _c("h4", [
              _vm._v(
                "Documentos en procesos de autorización (" +
                  _vm._s(
                    _vm.autorizacionDocumentos.documentosProcesoAutorizacion
                      .length
                  ) +
                  ")"
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "table-responsive" }, [
            _c("table", [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "tbody",
                [
                  _c(
                    "tr",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.autorizacionDocumentos
                              .documentosProcesoAutorizacion.length === 0,
                          expression:
                            "autorizacionDocumentos.documentosProcesoAutorizacion.length === 0"
                        }
                      ]
                    },
                    [
                      _c(
                        "td",
                        { attrs: { colspan: !_vm.form.en_cola ? 8 : 7 } },
                        [_c("strong", [_vm._v("No se encontró registros.")])]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(
                    _vm.autorizacionDocumentos.documentosProcesoAutorizacion,
                    function(comprobante, index) {
                      return _c(
                        "tr",
                        {
                          key: index,
                          class: {
                            "tr--canceled": comprobante.tiene_error === "S"
                          }
                        },
                        [
                          _c("td", [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  comprobante.tipo_comprobante.descripcion
                                ) +
                                "\n                "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(comprobante.numero_documento))
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(comprobante.fecha_emision_comprobante)
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(comprobante.cliente.nombre))
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                comprobante.valor_total !== null
                                  ? "$" +
                                      parseFloat(
                                        comprobante.valor_total
                                      ).toLocaleString(_vm.locale)
                                  : ""
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  comprobante.tiene_error === "S" ? "Sí" : "No"
                                ) +
                                "\n                "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "table-actions" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn-info btn--text",
                                attrs: {
                                  tooltip: "Visualizar",
                                  type: "button"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.visualizarComprobante(
                                      comprobante
                                    )
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fa fa-eye" })]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn-secondary btn--text",
                                attrs: { type: "button", tooltip: "Logs" },
                                on: {
                                  click: function($event) {
                                    return _vm.mostrarEventosComprobante(
                                      comprobante.id_comprobante
                                    )
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fa fa-file-o" })]
                            )
                          ])
                        ]
                      )
                    }
                  )
                ],
                2
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Tipo de documento")]),
        _vm._v(" "),
        _c("th", [_vm._v("# Documento")]),
        _vm._v(" "),
        _c("th", [_vm._v("Fecha de emisión")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cliente")]),
        _vm._v(" "),
        _c("th", [_vm._v("Total")]),
        _vm._v(" "),
        _c("th", [_vm._v("Error SRI")]),
        _vm._v(" "),
        _c("th")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Tipo de documento")]),
        _vm._v(" "),
        _c("th", [_vm._v("# Documento")]),
        _vm._v(" "),
        _c("th", [_vm._v("Fecha de emisión")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cliente")]),
        _vm._v(" "),
        _c("th", [_vm._v("Total")]),
        _vm._v(" "),
        _c("th", [_vm._v("Error SRI")]),
        _vm._v(" "),
        _c("th")
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14a9743e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14a9743e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/DashboardAutorizacionDocumentos.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-14a9743e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/DashboardAutorizacionDocumentos.vue
// module chunks = 0